import { useQueryClient } from "@tanstack/react-query";
import { useApi } from "@lending/lib/api";

const noop = () => Promise.resolve();

interface Props {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Record<string, string[]>) => void;
}
function useCreateApplicantIncomeDetailsQuery({ onSuccess = noop, onError }: Props = {}) {
  const $api = useApi();
  const queryClient = useQueryClient();

  return $api.useMutation("post", "/v2/lending/applicant_income_details/", {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["get", "/v2/lending/applicant_income_details/"],
      });
      await onSuccess();
    },
    onError,
  });
}

export { useCreateApplicantIncomeDetailsQuery };
